(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "3e6de32b0d0c9fb74ebed6bba6d1154950d3b314"
};